import http from "@/http/http.js";
import { getCookie } from "@/utils/getToken.js"
// let baseUrl = "/api/web/action/policy/springBoard";

let baseURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseURL = '/api/web/action/policy/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseURL = '/web/action/policy/springBoard';
}

// 政策需求列表（后台）
export function getPolicyNeedList(params) {
    return http.post(baseURL, {
        actionType: "getPolicyNeedList",
        actionBody: params
    });
}

// 需求信息备注提交(后台页面)
export function submitPolicyNeedNotes(params) {
    return http.post(baseURL, {
        actionType: "submitPolicyNeedNotes",
        actionBody: params
    });
}

